import { Partner } from '@/interfaces/Partner';
import { ImageWithMetadata } from '@andromeda/calvera-ui';
import { MercuryRetailer } from '@andromeda/polaris-data-access-products';

class Takeover {
    public Id: string;

    public Retailer: Partner;

    public Name: string;

    public MaxOffers: number;

    public MercuryRetailer: MercuryRetailer;

    public Image: ImageWithMetadata;

    public ItemIds: number[];

    public CarouselIndexItemId: Map<number, number>;

    public IngredientIdItemId: Map<number, number>;

    constructor(id: string, retailer: Partner, name: string, maxOffers: number, image: ImageWithMetadata, itemIds: number[],
        carouselIndexItemId: Map<number, number>, ingredientIdItemId: Map<number, number>) {
        this.Id = id;
        this.Retailer = retailer;
        this.Name = name;
        this.MaxOffers = maxOffers;
        this.MercuryRetailer = (this.Retailer === Partner.WALMART)
            ? MercuryRetailer.WALMART
            : MercuryRetailer.KROGER;
        this.Image = image;
        this.ItemIds = itemIds;
        this.CarouselIndexItemId = carouselIndexItemId;
        this.IngredientIdItemId = ingredientIdItemId;
    }
}

const wmt1 = new Takeover(
    'afe4c137-4ccf-41d8-97cf-778d9d55a76e',
    Partner.WALMART,
    'Walmart',
    5,
    new ImageWithMetadata(100, 100, '', 'https://crud-cdn.polaris.me/assets/images/980dfafa-f831-4e5a-8fa8-e6ecd179d9d5/100'),
    [426, 164, 438, 1188, 28, 2944, 179, 3463, 885],
    new Map<number, number>([[0, 179], [1, 885], [2, 3463]]),
    new Map<number, number>([
        [6541, 28],
        [6542, 164],
        [6543, 2944],
        [6544, 438],
        [6545, 426],
        [6546, 1188],
    ]),
);
const kro1 = new Takeover(
    'b36cab0b-0f8a-4267-b2d9-52e3e4708c00',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [2183, 163, 438, 1188, 28, 2944, 3203, 2105, 2332, 426],
    new Map<number, number>([[0, 2105], [1, 3203], [2, 2332]]),
    new Map<number, number>([
        [6862, 28],
        [6863, 163],
        [6864, 2944],
        [6865, 426],
        [6866, 2183],
        [6867, 1188],
        [6868, 438],
    ]),
);
const wmtDefault = new Takeover(
    '85eaf56b-45c3-433c-8248-9b0ad04369f3',
    Partner.WALMART,
    'Walmart',
    5,
    new ImageWithMetadata(100, 100, '', 'https://crud-cdn.polaris.me/assets/images/980dfafa-f831-4e5a-8fa8-e6ecd179d9d5/100'),
    [426, 164, 438, 1188, 28, 2944, 179, 3463, 885],
    new Map<number, number>([[0, 179], [1, 885], [2, 3463]]),
    new Map<number, number>([
        [6541, 28],
        [6542, 164],
        [6543, 2944],
        [6544, 438],
        [6545, 426],
        [6546, 1188],
    ]),
);

const kro1034 = new Takeover(
    'aadc6695-be21-4ac2-80ad-8f4c0eac68a8',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [14459, 14463, 14467],
    new Map<number, number>([[0, 14459], [1, 14463], [2, 14467]]),
    new Map<number, number>([]),
);

const kro1035 = new Takeover(
    '0824d0b1-5055-4e3a-8c33-038dd6b4215b',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const kro1080 = new Takeover(
    'd9ed6da1-c98d-43a4-b4f3-0ebfa290e8b4',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const wmt1033 = new Takeover(
    '75d8f32f-a7b5-4a7b-b40a-84440101fa4c',
    Partner.WALMART,
    'Walmart',
    5,
    new ImageWithMetadata(100, 100, '', 'https://crud-cdn.polaris.me/assets/images/980dfafa-f831-4e5a-8fa8-e6ecd179d9d5/100'),
    [],
    new Map<number, number>([]),
    new Map<number, number>([]),
);

const wmt1032 = new Takeover(
    '49dbd072-c344-4fed-8cd1-1f6c61db0e77',
    Partner.WALMART,
    'Walmart',
    5,
    new ImageWithMetadata(100, 100, '', 'https://crud-cdn.polaris.me/assets/images/980dfafa-f831-4e5a-8fa8-e6ecd179d9d5/100'),
    [],
    new Map<number, number>([]),
    new Map<number, number>([
        [9045, 14434],
    ]),
);

const kro1037 = new Takeover(
    'eed117d3-055c-437e-adf0-dad762a2c594',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const kro1076 = new Takeover(
    '436a1371-3e98-426a-a80a-dac5c265a641',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const kro1136 = new Takeover(
    'c17b4dc1-adf9-4604-8c70-75a6d2ec6175',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const kro0000 = new Takeover(
    'f63d1029-84da-4a66-bcdf-61dba0e9a866',
    Partner.KROGER,
    'Kroger',
    5,
    new ImageWithMetadata(100, 100, '', 'https://assets.polaris.me/images/081a3d91-f386-11ea-af91-0242ac110003/100.jpeg'),
    [],
    new Map<number, number>(),
    new Map<number, number>(),
);

const TakeoverCollection = new Map<string, Takeover>();
TakeoverCollection.set(wmt1.Id, wmt1);
TakeoverCollection.set(kro1.Id, kro1);
TakeoverCollection.set(kro1034.Id, kro1034);
TakeoverCollection.set(kro1035.Id, kro1035);
TakeoverCollection.set(kro1037.Id, kro1037);
TakeoverCollection.set(kro1076.Id, kro1076);
TakeoverCollection.set(kro1080.Id, kro1080);
TakeoverCollection.set(kro1136.Id, kro1136);
TakeoverCollection.set(wmt1033.Id, wmt1033);
TakeoverCollection.set(wmt1032.Id, wmt1032);
TakeoverCollection.set(kro0000.Id, kro0000);
// TakeoverCollection.set(wmtDefault.Id, wmtDefault);

export {
    Takeover,
    TakeoverCollection,
};
